<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{templateId ? 'Update' : 'Add'}} Template</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="templateForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Actions</mat-label>
                <mat-select formControlName="action" (selectionChange)="handleActionChange($event)">
                  <mat-option *ngFor="let item of actionList" [value]="item?.emailTemplatingActionId">{{item.actionName}}</mat-option>
                </mat-select>
                <mat-error *ngIf="templateForm.controls['action'].touched && templateForm.controls['action'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="auto" appearance="outline" *ngIf="statusList?.length">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status"  (selectionChange)="handleStatusChange($event)">
                  <mat-option *ngFor="let item of statusList"  [value]="item?.emailTemplateActionStatusId">{{item.statusName}}</mat-option>
                </mat-select>
                <mat-error *ngIf="templateForm.controls['status'].touched && templateForm.controls['status'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
            </div>
            
      
              <fxLayout fxLayout="column" *ngIf="showTemplateEditor" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
                <mat-label>Description</mat-label>
                <ckeditor [config]="editorConfig" formControlName="templateContent" width="100%" debounce="500"></ckeditor>
                <mat-error
                  *ngIf="templateForm.controls['templateContent'].touched && templateForm.controls['templateContent'].hasError('required')" style="font-size:13px;">
                  This is a required field.</mat-error>
              </fxLayout>

              
              
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="addEdit()"><span>{{templateId ? 'Update' : 'Add'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="redirectToGlobalEmailTemplate()"><span>Cancel</span></button>
          </div>
          </form>
    </div>
  </div>



